import type { ShiftAssignment, ShiftAssignmentShiftRef } from '@/types/shift.types'

const HH_MM_RE = /^([01]\d|2[0-3]):[0-5]\d$/

function getShiftRef(assignment: ShiftAssignment): ShiftAssignmentShiftRef | undefined {
  return assignment.shiftId && typeof assignment.shiftId === 'object'
    ? assignment.shiftId
    : undefined
}

export function getIncompleteShiftIssues(
  assignment: ShiftAssignment | null | undefined,
): string[] {
  if (!assignment) return ['No shift assignment is linked to this action.']

  const shiftRef = getShiftRef(assignment)
  const name =
    assignment.slotName ||
    assignment.templateSnapshot?.name ||
    assignment.shift?.name ||
    shiftRef?.name
  const startTime = assignment.startTime || assignment.shift?.startTime || shiftRef?.startTime
  const endTime = assignment.endTime || assignment.shift?.endTime || shiftRef?.endTime
  const issues: string[] = []

  if (!name?.trim()) issues.push('Shift name is missing.')
  if (!assignment.userId) issues.push('Assigned staff member is missing.')
  if (!assignment.date) issues.push('Shift date is missing.')
  if (!startTime || !HH_MM_RE.test(startTime)) issues.push('Start time is missing or invalid.')
  if (!endTime || !HH_MM_RE.test(endTime)) issues.push('End time is missing or invalid.')

  ;(assignment.breakAllowances ?? []).forEach((breakAllowance, index) => {
    const label = `Break ${index + 1}`
    if (!breakAllowance.name?.trim()) issues.push(`${label} name is missing.`)
    if (breakAllowance.duration == null || breakAllowance.duration < 0) {
      issues.push(`${label} duration is missing or invalid.`)
    }
    if (
      breakAllowance.scheduledStartTime &&
      !HH_MM_RE.test(breakAllowance.scheduledStartTime)
    ) {
      issues.push(`${label} scheduled start time is invalid.`)
    }
  })

  return issues
}

export function isIncompleteShift(
  assignment: ShiftAssignment | null | undefined,
): boolean {
  return getIncompleteShiftIssues(assignment).length > 0
}
